module.exports = __webpack_public_path__ + "static/17invgde-2953a76c389e206fdeb364076d12b0da.gif";